import { useEffect } from 'react';

const broadcastChannel = new BroadcastChannel('lastViewedMessage');

interface LastViewedMessageMessage {
  chatId: string;
  messageId: string;
}

interface UseBroadcastLastViewedChatParams {
  onReceiveLastViewedMessage: (lastViewedMessage: LastViewedMessageMessage) => void;
}

const useBroadcastLastViewedChat = ({
  onReceiveLastViewedMessage,
}: UseBroadcastLastViewedChatParams) => {
  const broadcastLastViewedMessage = (message: LastViewedMessageMessage) => {
    broadcastChannel.postMessage(message);
  };

  useEffect(() => {
    broadcastChannel.onmessage = (event) => {
      onReceiveLastViewedMessage(event.data as LastViewedMessageMessage);
    };
  }, []);

  return { broadcastLastViewedMessage };
};

export default useBroadcastLastViewedChat;
